import { NIVEAU_5_UNLOCKED_KEYS } from '../data/curriculum/niveau-5';
import type { FlowLexicon } from '../types';

const API_BASE = import.meta.env.VITE_API_URL ?? '';

export type FlowApiMode = 'live' | 'mock';

export interface FlowChunkResult {
  text: string;
  topic: string;
  mode: FlowApiMode;
}

export async function fetchFlowHealth(): Promise<FlowApiMode | null> {
  try {
    const res = await fetch(`${API_BASE}/api/health`, {
      credentials: 'include',
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { flow?: FlowApiMode };
    return data.flow === 'live' || data.flow === 'mock' ? data.flow : null;
  } catch {
    return null;
  }
}

const FLOW_FETCH_MS = 18_000;

export async function fetchFlowChunk(body: {
  lexicon: FlowLexicon;
  excludeTopics: string[];
}): Promise<FlowChunkResult | null> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), FLOW_FETCH_MS);

  try {
    const res = await fetch(`${API_BASE}/api/flow/chunk`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        lexicon: body.lexicon,
        excludeTopics: body.excludeTopics,
        unlockedKeys: NIVEAU_5_UNLOCKED_KEYS,
        strictCase: true,
      }),
      signal: controller.signal,
    });
    if (!res.ok) return null;
    const data = (await res.json()) as FlowChunkResult;
    if (typeof data.text !== 'string' || typeof data.topic !== 'string') {
      return null;
    }
    return data;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
